var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18 8.83203L22 12.832M22 12.832L18 16.832M22 12.832H9M15 5.03607C13.7252 4.27031 12.2452 3.83203 10.6667 3.83203C5.8802 3.83203 2 7.86147 2 12.832C2 17.8026 5.8802 21.832 10.6667 21.832C12.2452 21.832 13.7252 21.3938 15 20.628",
    stroke: "#B42318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.0703b57e6949e9930d296e0c06694c4e.svg";
export { ForwardRef as ReactComponent };